"use strict";

export default {
  install: (Vue, config = { appName: "app" }) => {
    const appName = config.appName;

    const Storage = {
      setUser (user) {
        this.set("user", user);
      },

      getUser () {
        return this.get("user");
      },

      existUser () {
        return this.exist("user");
      },

      removeUser () {
        this.remove("user");
      },

      // LocalStorage
      set (key, value) {
        localStorage.setItem(appName + "_" + key, JSON.stringify(value));
      },

      get (key) {
        let data = localStorage.getItem(appName + "_" + key);
        try {
          return JSON.parse(data);
        } catch (Exception) {
          return data;
        }
      },

      remove (key) {
        localStorage.removeItem(appName + "_" + key);
      },

      destroy (key) {
        this.remove(key);
      },

      exist (key) {
        var value = localStorage.getItem(appName + "_" + key);
        return (
          typeof value !== "undefined" &&
          value !== undefined &&
          value !== null &&
          value !== "null" &&
          value !== "[]"
        );
      },

      // SessionStorage
      setSession (key, value) {
        sessionStorage.setItem(appName + "_" + key, JSON.stringify(value));
      },

      getSession (key) {
        return JSON.parse(sessionStorage.getItem(appName + "_" + key));
      },

      removeSession (key) {
        sessionStorage.removeItem(appName + "_" + key);
      },

      existSession (key) {
        var value = sessionStorage.getItem(appName + "_" + key);
        return (
          typeof value !== "undefined" &&
          value !== undefined &&
          value !== null &&
          value !== "null" &&
          value !== "[]"
        );
      },

      // OIDC refresh helpers
      setOidcRefreshToken (value) {
        this.setSession("refresh_token", value);
      },

      getOidcRefreshToken () {
        return this.getSession("refresh_token");
      },

      setOidcExpiresAt (value) {
        this.setSession("expires_at", value);
      },

      getOidcExpiresAt () {
        return this.getSession("expires_at");
      },

      //  ciudadania digital
      setOidcCode (value) {
        sessionStorage.setItem(`oidc_code`, value);
      },

      setOidcState (value) {
        sessionStorage.setItem(`oidc_state`, value);
      },

      setOidcSession_state (value) {
        sessionStorage.setItem(`oidc_session_state`, value);
      },

      setRequestNonce (value) {
        sessionStorage.setItem(`request_nonce`, value);
      },

      setRequestState (value) {
        sessionStorage.setItem("request_state", value);
      },

      getOidcCode () {
        return sessionStorage.getItem(`oidc_code`);
      },

      getOidcState () {
        return sessionStorage.getItem(`oidc_state`);
      },

      getOidcSession_state () {
        return sessionStorage.getItem(`oidc_session_state`);
      },

      getRequestNonce () {
        return sessionStorage.getItem(`request_nonce`);
      },

      getRequestState () {
        return sessionStorage.getItem("request_state");
      },

      // Flash Data
      getFlash (key) {
        if (this.exist(key)) {
          var value = this.get(key);
          this.remove(key);
          return value;
        }
        return false;
      },

      flash (key) {
        this.getFlash(key);
      },

      removeAll () {
        localStorage.clear();
      }
    };

    Vue.prototype.$storage = Storage;
  }
};



// WEBPACK FOOTER //
// ./src/lib/storage.js